import { AdvanceModel } from "../advancesSlice"
import { RootState } from "../store"
import { SubmissionModel, isSubmitted } from "../submissionsSlice"

/**
 * This selector returns all sharing-ministry submissions (CHM, Sedera, or SMI,
 * initial or add-on) that have any of the same expense ids as the advance.
 * @param advance
 * @returns
 */
export function selectMinistrySubmissionsCoveredByAdvance(advance: AdvanceModel): (state: RootState) => SubmissionModel[] {
  return (s) => s.submissions.submissions
    .filter(submission =>
      submission.incident_id === advance.incident_id &&
      (submission.submission_type === 'CHM' || submission.submission_type === 'CHM-addon' ||
        submission.submission_type === 'Sedera' || submission.submission_type === 'Sedera-addon' ||
        submission.submission_type === 'SMI' || submission.submission_type === 'SMI-addon')
    )
    .filter((submission) => {
      // Find which submissions have any of the same expense ids as the advance
      return submission.expense_ids?.some(id => advance.expense_ids.includes(id)) || false
    })
}
